<template>
  <div class="bg-container page" :style="{ background: 'linear-gradient(90deg, rgba(223, 53, 173, 0.8), rgba(79, 29, 181, 0.8))' }">
    <div class="bg-wrapper" :style="{ background: 'url(/img/login/lgbg.png) 50% center / 100% no-repeat' }">
      <div class="login">
        <van-nav-bar class="nav-bar">
          <template #left>
            <van-icon name="arrow-left" color="#fff" @click="back()" />
          </template>
          <template #right>
            <div class="language" @click="$router.push('/language')">
              <div class="langs">{{ currentLangName }}</div>
            </div>
          </template>
        </van-nav-bar>
        <div class="wrapper">
          <img src="/img/logo.png" style="display: block; margin: 10px auto 15px; width: 12rem;" />
          <div class="loginForm">
            <van-field
              v-model="username"
              clearable
              input-align="center"
              class="input"
              :placeholder="$t('auth.username_place')"
            >
              <template slot="left-icon">
                <img src="/img/login/zh.png" />
              </template>
            </van-field>
            <van-field
              v-model="password"
              :type="passwordType"
              input-align="center"
              class="input"
              :placeholder="$t('auth.pwd_place')"
            >
              <template slot="left-icon">
                <img src="/img/login/mm.png" />
              </template>
              <template slot="right-icon">
                <van-icon
                  :name="passwordType === 'password' ? 'closed-eye' : 'eye-o'"
                  @click="switchPasswordType"
                />
              </template>
            </van-field>
            <van-button
              class="login-btn"
              type="primary"
              size="normal"
              @click="doLogin()"
              >{{$t("auth.login")}}</van-button
            >
            <div @click="toRegister()" class="register-text">
              <span style="font-size: 18px; text-shadow: rgb(255, 255, 255) 0px 0px 1.333vw, rgb(230, 0, 115) 0px 0px 5.333vw, rgb(230, 0, 115) 0px 0px 10.667vw;">{{$t("auth.no_account")}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  model: {
    prop: "inputValue",
    event: "input",
  },
  props: {
    /**
     * 当前输入的值
     */
    inputValue: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      username: "",
      lang: 'en',
      password: this.inputValue,
      passwordType: "password",
      currentLangName: "English",
    };
  },
  mounted(){
    this.lang = localStorage.getItem("lang") || 'en'
    this.updateLangName()
  },
  methods: {
    updateLangName() {
      const langMap = {
        'en': 'English',
        'zh': '中文',
        'ja': '日本語',
        'kr': '한국어',
        'tr': 'Türkçe',
        'gr': 'Ελληνικά',
        'fe': 'Filipino',
        'ia': 'Italiano',
        'rs': 'Русский',
        'sa': 'Español'
      }
      this.currentLangName = langMap[this.lang] || 'English'
    },
    switchPasswordType() {
      this.passwordType =
        this.passwordType === "password" ? "text" : "password";
    },
    back() {
      return window.history.back();
    },
    toRegister() {
      this.$router.push("Register");
    },
    doLogin() {
      if (
        this.username === "" ||
        this.username === null ||
        this.username === undefined
      ) {
        this.$toast(this.$t("auth.username_place"));
        return false;
      }
      if (
        this.password === "" ||
        this.password === null ||
        this.password === undefined
      ) {
        this.$toast(this.$t("auth.pwd_place"));
        return false;
      }
      this.$http({
        url: "member_login",
        method: "get",
        data: { 
          username: this.username, 
          password: this.password,
        },
      }).then((res) => {
        if (res.code === 200) {
          this.$toast.success(res.msg);
          localStorage.setItem("token", res.data.id);
          this.$router.push("Mine");
        } else {
          this.$toast(res.msg);
        }
      });
    },
  },
  created() {
    if (localStorage.getItem("token")) {
      return window.history.back();
    }
  },
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";

.login {
  height: 100%;
}
.bg-container .bg-wrapper .login .nav-bar {
  background: 0 0;
}

.language{
  cursor: pointer;
}
.langs {
  padding: 0 2.667vw;
  line-height: 10.667vw;
  font-size: 3.733vw;
  color: #fff;
  border: 1px solid #fff;
  border-radius: 1.067vw;
}

.login .wrapper {
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.logo-container {
  margin: 0 auto;
  width: 45%;
}
.logo-container .logo-wrapper {
  position: relative;
  padding-bottom: 62.5%;
}
.logo-container .logo-wrapper .logo-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  -o-object-fit: contain;
  object-fit: contain;
}
.login .wrapper .loginForm {
  padding: 2.667vw 5.333vw;
}
.login .wrapper .loginForm .input {
  width: 100%;
  height: 3.66667rem;
  margin: 1rem auto;
  border-radius: 0.33333rem;
  overflow: hidden;
  background: rgba(79, 79, 79, 0.8);
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0 2.33333rem;
}
::v-deep .van-field__right-icon .van-icon {
  font-size: 6.667vw;
}
::v-deep .van-field__control {
  font-size: 3.733vw;
  line-height: 5.333vw;
  text-align: left;
  padding-left: 4vw;
  color: #fff;
}
::v-deep .van-field__control::placeholder {
  color: rgba(255, 255, 255, 0.5);
}
::v-deep .van-icon {
  font-size: 6.667vw;
}
.login .wrapper .loginForm .reset-text {
  margin: 4vw 2vw;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.login .wrapper .loginForm .reset-text span {
  color: #fff;
  font-size: 3.333vw;
  font-weight: 500;
  line-height: 2vw;
}
.login .wrapper .loginForm .register-text {
  margin: 8vw 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.login .wrapper .loginForm .register-text span {
  color: #fff;
  font-size: 3.333vw;
  font-weight: 500;
  line-height: 2.667vw;
}
.login .wrapper .loginForm .login-btn {
  margin-top: 0;
  width: 100%;
  height: 13.333vw;
  color: #fff;
  background: linear-gradient(90deg, rgba(223, 53, 173, 0.8), rgba(79, 29, 181, 0.8));
  border-radius: 0.33333rem;
  font-size: 4vw;
  font-weight: bolder;
  border: none;
}
</style>
